<template>
  <div>
    <h5>Métodos de pago automáticos guardados.</h5>
    <b-row>
      <b-col md="6">
        <div class="card">
          <div class="card-body" v-if="getUserMp">
            <b-row>
              <b-col sm="12" v-for="(card, id) in getUserMp.cards" :key="id">
                <CreditCardComponent :card="card" :cardId="cardId" v-if="card"/>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="3">
                <p class="text-footer">
                  Procesado por
                </p>
              </b-col>
              <b-col sm="3">
                <p class="logo"></p>
              </b-col>
              <b-col sm="6">
                <p class="text-footer">
                  Al pagar, afirmo que soy mayor de edad y acepto los Términos y condicionesde Mercado Pago.
                </p>
              </b-col>
            </b-row>
          </div>
        </div>
      </b-col>
      <b-col  md="6" v-if="cardId">
        <b-button variant="outline-danger" @click="disableAutomaticPayment" >Cancelar pago automático</b-button>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import gql from 'graphql-tag'
import CreditCardComponent from './registerAutomaticPayment/index'
import headers from '@/config/headers.js'
const GET_USER_MP = gql`
  query getUserMp($email: String){
    getUserMp(email: $email) {
      id
      first_name
      cards{
        id
        last_four_digits
        expiration_month
        expiration_year
        cardholder{
          name
        }
        issuer{
          id
          name
        }
        payment_method{
          id
          name
          thumbnail
          secure_thumbnail
        }
      }
    }
  }
`
const GET_CONCECIONARIO_BY_ID = gql`
  query getConcesionarioId($id: Int) {
    getConcesionarioId(id: $id){
      id
      name
      automaticPayment
      cardId
    }
  }
`
const DISABLE_AUTOMATIC_PAYMENT = gql`
mutation disableAutomaticPayment($concesionarioId: Int){
  disableAutomaticPayment(concesionarioId: $concesionarioId){
    id
    name
    email
  }
}
`
export default {
  components: {
    CreditCardComponent,
  },
  data() {
    return {
      cardId: null,
    }
  },
  apollo: {
    getUserMp: {
      query: GET_USER_MP,
      context: headers(),
      variables () {
        return {
          email: this.$store.state.user.email,
        }
      },
      result({ data }) {
        console.log(data)
      },
      error(error) {
        console.log(error)
      },
    },
    getConcesionarioId: {
      query: GET_CONCECIONARIO_BY_ID,
      context: headers(),
      variables() {
        return {
          id: parseInt(this.$store.state.user.franchisee),
        }
      },
      result({ data }) {
        console.log(data)
        this.cardId = data.getConcesionarioId.automaticPayment
      },
      error(error) {
        console.log(error)
      },
    },
  },
  methods: {
    disableAutomaticPayment() {
      this.$apollo.mutate({
        mutation: DISABLE_AUTOMATIC_PAYMENT,
        context: headers(),
        variables: {
          concesionarioId: parseInt(this.$store.state.user.franchisee),
        },
      })
        .then(result => {
          this.makeToast(true, 'success', 'Pago automático cancelado', 'Pago automático cancelado correctamente.')
        })
        .catch(error => {
          console.log(error)
        })
    },
    makeToast(append = false, variant, title, message) {
      this.$bvToast.toast(message, {
        title: title,
        autoHideDelay: 5000,
        appendToast: append,
        variant: variant,
      })
    },
  },
}
</script>
<style>
.text-footer {
  font-size: 9px;
  color: #999;
}
.logo {
  width: 5.25em;
  height: 1.25em;
  background: url('https://http2.mlstatic.com/resources/frontend/statics/fury_px-checkout-frontend/e9700bddbbe3d0e284fbc07c266041cd.png') no-repeat;
}
</style>
